export const ConnectorAlias = {
    CHYT: 'chyt_connectors',
};

import {ConnectorType} from 'shared';

/** Connections created via biConverter and rendered by custom react-components */
export const S3_BASED_CONNECTORS = [
    ConnectorType.Csv,
    ConnectorType.File,
    ConnectorType.GsheetsV2,
    ConnectorType.Yadocs,
];
